import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=175e62a2&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports